module.exports = __webpack_public_path__ + "static/media/hellmanns.5cc5154d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marcas/hellmanns.png
// module id = 948
// module chunks = 0